import React, { useContext, useEffect } from "react"
import intl from "react-intl-universal"
import { useNavigate } from "react-router-dom"

import ModalAddPainel from "../ModalAddPainel"
import PaineisContext from "../../../contexts/Paineis"
import ModalConfirmDelete from "../ModalAddPainelCancel"
import useDataApi from "../../../hooks/useDataApi"
import {
    createPainel,
    delPainel,
    EditPainel,
} from "../../../services/paineis"
import RcmpModalInfo from "../ModalInfo"

export default function RcmpModalsPanel() {
    const [oCreatePanelRes, fnCreatePanelReq, fnResetCreatePanel] = useDataApi(createPainel)
    const [oEditPanelRes, fnEditPanelReq, fnResetEditPanel] = useDataApi(EditPainel)
    const [oDeletePanelRes, fnDeletePanelReq] = useDataApi(delPainel)

    const {
        oCurrentPanel,
        bIsOpenAddPanel,
        fnSetBIsOpenAddPanel,
        bIsEditPanel,
        fnSetBIsEditPanel,
        bIsOpenDeleteAlertPanel,
        fnSetBIsOpenDeleteAlertPanel,
        bIsOpenDeleteWarningPanel,
        fnSetBIsOpenDeleteWarningPanel,
        bIsOpenDeletePanel,
        fnSetBIsOpenDeletePanel,
        fnSetBUpdatePanelsList,
        getSelectedPaineis,
        oBoardsRes,
        fnSetOCurrentPanel,
    } = useContext(PaineisContext)

    const fnNavigate = useNavigate()

    useEffect(() => {
        if (!oCreatePanelRes.done || !oCreatePanelRes.data) return
        fnSetBUpdatePanelsList(true)
    }, [oCreatePanelRes])

    useEffect(() => {
        if (!oEditPanelRes.done || !oEditPanelRes.data) return
        fnSetBUpdatePanelsList(true)
        getSelectedPaineis(true)
    }, [oEditPanelRes])

    useEffect(() => {
        if (!oDeletePanelRes.done || !oDeletePanelRes.data) return
        fnNavigate("/")
        fnSetBUpdatePanelsList(true)
        getSelectedPaineis(true)
    }, [oDeletePanelRes])

    useEffect(() => {
        if (!bIsOpenAddPanel) {
            fnResetCreatePanel()
            fnResetEditPanel()
        }
    }, [bIsOpenAddPanel])

    async function fnCreatePanel(data) {
        await fnCreatePanelReq(data)
    }

    async function fnDeletePanel(data) {
        return await fnDeletePanelReq(data)
    }

    async function fnEditPainel(data) {
        const response = await fnEditPanelReq(data)
        fnSetOCurrentPanel(response.data)
    }

    function fnCloseAddPanelModal() {
        fnSetBIsOpenAddPanel(false)
        fnSetBIsEditPanel(false)
    }

    function fnConfirmModalDeleteWarning() {
        fnSetBIsOpenDeletePanel(true)
    }

    function fnCloseModalDeleteWarning() {
        fnSetBIsOpenDeleteWarningPanel(false)
    }

    function fnCloseModalDelete() {
        fnSetBIsOpenDeletePanel(false)
        fnCloseModalDeleteWarning()
    }

    function fnHandleCloseAlertDeleteModal() {
        fnSetBIsOpenDeleteAlertPanel(false)
    }

    return (
        <>
            <ModalAddPainel
                handleEditPainel={fnEditPainel}
                onClose={fnCloseAddPanelModal}
                onCancel={fnCloseAddPanelModal}
                isOpen={bIsOpenAddPanel}
                createCard={fnCreatePanel}
                isEdit={bIsEditPanel}
                oPainelData={oCurrentPanel}
                oPanelRes={bIsEditPanel ? oEditPanelRes : oCreatePanelRes}
            />
            <RcmpModalInfo
                size={"sm"}
                bIsOpen={bIsOpenDeleteWarningPanel}
                buttonCancelText={intl.get("cancel")}
                buttonSaveText={intl.get("continue")}
                title={intl.get("DashboardPage.delete_panel")}
                description={intl.get("confirm_operation")}
                fnHandleCancel={fnCloseModalDeleteWarning}
                fnHandleConfirm={fnConfirmModalDeleteWarning}
            />
            <ModalConfirmDelete
                fnOnClose={fnCloseModalDelete}
                isOpen={bIsOpenDeletePanel}
                idPainel={oCurrentPanel?.id}
                fnHandleDelete={fnDeletePanel}
                bOnDelete={true}
                text={intl.get("DashboardPage.sure_to_delete_panel", {
                    panel: oCurrentPanel?.name,
                })}
                headerText={intl.get("DashboardPage.delete_panel")}
            />
            <RcmpModalInfo
                bIsOpen={bIsOpenDeleteAlertPanel}
                buttonSaveText={intl.get("close")}
                title={intl.get("DashboardPage.delete_panel")}
                description={intl.get("DashboardPage.delete_block_with_board")}
                size={"sm"}
                oResponse={oBoardsRes}
                oButtonCancelProps={{ style: { display: "none" } }}
                oButtonSaveProps={{ style: { marginLeft: "auto" } }}
                fnHandleCancel={fnHandleCloseAlertDeleteModal}
                fnHandleConfirm={fnHandleCloseAlertDeleteModal}
            />
        </>
    )
}
